import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Navbar, Nav, Tabs, Tab, Row, Col } from 'react-bootstrap';
import PlanColumns from './planColumns';
import { WebPlanContext } from '../../utils/webPlanContext';
import { SmoothScrollLink } from '../../utils/navUtils';
import localizedPath from '../../utils/localization';

import './plansWidget.scss';

function PlansWidget() {
    const { t } = useTranslation();
    const { currentWebPlan, setWebPlan } = useContext(WebPlanContext);

    return (
        <div className="plans-columns-wrapper">
            <Row className="mb-3">
                <Col md={12} className="text-center">
                    <h3 className="plans-subtitle">{t('titles.payment-period')}</h3>
                    <Tabs
                        id="plans-tabs"
                        activeKey={currentWebPlan}
                        onSelect={(k) => {
                            setWebPlan(k);
                        }}
                    >
                        <Tab eventKey="one" title={`1 ${t('titles.year')}`}>
                            <PlanColumns period={1} />
                        </Tab>
                        <Tab
                            eventKey="two"
                            title={
                                <span>
                                    2 {t('titles.years')} <sup>-10%</sup>
                                </span>
                            }
                        >
                            <PlanColumns period={2} />
                        </Tab>
                        <Tab
                            eventKey="three"
                            title={
                                <span>
                                    3 {t('titles.years')} <sup>-15%</sup>
                                </span>
                            }
                        >
                            <PlanColumns period={3} />
                        </Tab>
                    </Tabs>
                    <Nav className="all-plans-link">
                        <SmoothScrollLink to={localizedPath('/hosting/web#all-plans-section')}>
                            <Navbar.Brand>
                                <u>{t('buttons.see-features')}</u>
                            </Navbar.Brand>
                        </SmoothScrollLink>
                    </Nav>
                </Col>
            </Row>
        </div>
    );
}

export default PlansWidget;
